import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import javascriptCircle from "../assets/javascript_circle.png";
import tensorflow from "../assets/tensorflow.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import ai from "../assets/AI.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profilePic from "../assets/ProfilePic.jpeg";
import profile from "../assets/profile.png";
import profile2 from "../assets/profile2.png";
import profile3 from "../assets/profile3.png";
import profile4 from "../assets/profile4.png";

import manInComputer from "../assets/casual-life-3d-32.png";
import manStanding from "../assets/casual-life-3d-22.png";
import team from "../assets/team.png";
import manStandingCell from "../assets/casual-life-3d-young-man-holding-blue-smartphone.png";

import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import logo_custom from "../assets/logo_custom.svg";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";

export default {
  profilePic,
  ai,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  javascriptCircle,
  tensorflow,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  profile2,
  profile3,
  profile4,
  manInComputer,
  manStanding,
  manStandingCell,
  team,
  circle,
  logo,
  logo_custom,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};
